var _desc, _rect, _defs, _g, _path, _path2, _path3, _path4, _rect2, _path5, _use, _rect3, _g2, _use2, _use3, _path6, _g3, _use4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 846,
    height: 510,
    viewBox: "0 0 282 170",
    id: "bc_flag",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flag of British Columbia")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 72,
    fill: "#002b7f"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "border"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 72
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#border)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 282,72 M 282,0 L 0,72",
    strokeWidth: 24,
    stroke: "white",
    id: "diags_white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 282,72 M 282,0 L 0,72",
    strokeWidth: 18,
    stroke: "#CF142B",
    id: "diags_red"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "white",
    d: "M 141,36 l-141,-36 h40 l 141,36 z M 141,36 l 141,-36 v11 l -141,36 z M 141,36 l141,36 h-40 l -141,-36 z M 141,36 l -141,36 v-11 l 141,-36 z",
    id: "eraser_white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,24 h129 v-24 h24 v24 h129 v24 h-129 v24 h-24 v-24 h-129z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,27 h132 v-27 h18 v27 h132 v18 h-132 v27 h-18 v-27 h-132z",
    fill: "#ce1126"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141,43)",
    style: {
      fill: "#ffd600",
      stroke: "DarkGoldenRod",
      strokeWidth: "0.25px"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,-22 L6.5,-9.5 L15,-21 L17,-8.5 L29,-18 L20,0 A20,2 0 0,1 -20,0 L-29,-18 L-17,-8.5 L-15,-21 L-6.5,-9.5 L0,-22 z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20,0 a20,2 0 0,0 -40,0 M20.5,-1 a20.5,2 0 0,0 -41,0 M22.5,-5 a22.5,3 0 0,0 -45,0 M23,-6 a23,3 0 0,0 -46,0",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -7,
    height: 3,
    width: 6,
    rx: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "stl",
    d: "M8.51,-5.245 C8.4,-3.335 13.35,-3.09 13.55,-4.875 C13.747787,-6.6402494 8.6198722,-7.1527809 8.51,-5.245z M19.11,-4.245 C18.724973,-3.2356046 21.641781,-1.323814 22.42,-2.99 C23.2,-4.66 19.48,-5.215 19.11,-4.245 z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stl",
    transform: "scale(-1,1)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 72,
    width: 282,
    height: 98,
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(141,81)",
    fill: "#002b7f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sb",
    d: "M0,0 c10,0 18.1,5 28.2,5 c10,0 18.1,-5 28.2,-5 c10,0 18.1,5 28.2,5 c10,0 18.1,-5 28.2,-5 c10,0 18.1,5 28.2,5 v14 c-10,0 -18.1,-5 -28.2,-5 c-10,0 -18.1,5 -28.2,5 c-10,0 -18.1,-5 -28.2,-5 c-10,0 -18.1,5 -28.2,5 c-10,0 -18.1,-5 -28.2,-5z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sb",
    transform: "scale(-1,1)"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(0,28)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(0,56)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141,252)",
    style: {
      fill: "#ffd600",
      stroke: "DarkGoldenRod",
      strokeWidth: "0.25px"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M0,0L-5.86,-111.84L0,-175L5.86,-111.84z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "sw"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(12)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(24)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(36)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M0,0L -5.86,-111.84 C-5.86,-111.84 -3,-116 -3,-120 C-3,-124 -5,-126 -5,-131 C-5,-136 0,-140 0,-144 C0,-150 -5,-152 -5,-158 C-5,-164 0,-166 0,-175 C0,-153 9,-153 9,-144 C9,-136.5 2,-134 2,-126 C2,-118 5.86,-111.84 5.86,-111.84z",
    transform: "rotate(6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    transform: "rotate(12)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    transform: "rotate(24)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    transform: "rotate(36)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    transform: "rotate(48)"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sw",
    transform: "scale(-1,1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 112
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBc);
export default __webpack_public_path__ + "static/media/bc.6769c8cf53a9a4b6add87a92b77d251f.svg";
export { ForwardRef as ReactComponent };